"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var react_router_dom_1 = require("react-router-dom");
var clsx_1 = require("clsx");
var VerticalItem_1 = require("./VerticalItem");
var AppContext_1 = require("../../../utility/AppContext");
var Box_1 = require("@material-ui/core/Box");
var IntlMessages_1 = require("../../../utility/IntlMessages");
var VerticalCollapase_style_1 = require("./VerticalCollapase.style");
var react_redux_1 = require("react-redux");
var Utils_1 = require("../../../utility/Utils");
var CustomIcon_1 = require("../../../../shared/components/Custom/CustomIcon");
var needsToBeOpened = function (pathname, item) {
    if (pathname) {
        return isUrlInChildren(item, pathname);
    }
    return false;
};
var isUrlInChildren = function (parent, url) {
    if (!parent.children) {
        return false;
    }
    for (var i = 0; i < parent.children.length; i++) {
        if (parent.children[i].children) {
            if (isUrlInChildren(parent.children[i], url)) {
                return true;
            }
        }
        if (parent.children[i].url === url ||
            url.includes(parent.children[i].url)) {
            return true;
        }
    }
    return false;
};
var VerticalCollapse = function (_a) {
    var item = _a.item, level = _a.level;
    var _b = (0, react_1.useContext)(AppContext_1.default), theme = _b.theme, themeMode = _b.themeMode;
    var classes = (0, VerticalCollapase_style_1.default)({ level: level, themeMode: themeMode });
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var _c = (0, react_1.useState)(function () { return needsToBeOpened(pathname, item); }), open = _c[0], setOpen = _c[1];
    (0, react_1.useEffect)(function () {
        if (needsToBeOpened(pathname, item)) {
            setOpen(true);
        }
    }, [pathname, item]);
    var handleClick = function () {
        setOpen(!open);
    };
    var user = (0, react_redux_1.useSelector)(function (_a) {
        var auth = _a.auth;
        return auth;
    }).user;
    var hasPermission = (0, react_1.useMemo)(function () { return (0, Utils_1.checkPermission)(item.auth, user.role); }, [
        item.auth,
        user,
    ]);
    if (!hasPermission) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(core_1.ListItem, { button: true, component: 'li', className: (0, clsx_1.default)(classes.navItem, 'nav-item', open && 'open'), onClick: handleClick },
            item.icon && (React.createElement(Box_1.default, { component: 'span', mr: 6 },
                React.createElement(core_1.Icon, { color: 'action', className: (0, clsx_1.default)('nav-item-icon', classes.listIcon) }, item.icon))),
            item.customIcon && (React.createElement(Box_1.default, { component: 'span', mr: 6 },
                React.createElement(CustomIcon_1.CustomIcon, { width: '24px', height: '24px', className: (0, clsx_1.default)('nav-item-icon', classes.listIcon) }))),
            React.createElement(core_1.ListItemText, { classes: { primary: (0, clsx_1.default)('nav-item-text', classes.listItemText) }, primary: React.createElement(IntlMessages_1.default, { id: item.messageId }) }),
            React.createElement(Box_1.default, { p: 0, clone: true },
                React.createElement(core_1.IconButton, { disableRipple: true },
                    React.createElement(core_1.Icon, { className: 'nav-item-icon-arrow', color: 'inherit' }, open
                        ? 'expand_more'
                        : theme.direction === 'ltr'
                            ? 'chevron_right'
                            : 'chevron_left')))),
        item.children && Array.isArray(item.children) && (React.createElement(core_1.Collapse, { in: open, className: 'collapse-children' }, item.children.map(function (item) { return (React.createElement(React.Fragment, { key: item.id },
            item.type === 'collapse' && (React.createElement(VerticalCollapse, { item: item, level: level + 1 })),
            item.type === 'item' && (React.createElement(VerticalItem_1.default, { item: item, level: level + 1 })))); })))));
};
exports.default = React.memo(VerticalCollapse);
//# sourceMappingURL=VerticalCollapse.js.map